const establishments = () => import(/* webpackChunkName: "base" */ '@/views/establishments/main')
const list = () => import(/* webpackChunkName: "base" */ '@/views/establishments/list')
const addSheet = () => import(/* webpackChunkName: "sheets" */ '@/sui/views/sheet/add')
const sheet = () => import(/* webpackChunkName: "sheets" */ '@/sui/views/sheet/main')
const module = () => import(/* webpackChunkName: "base" */ '@/views/module/main')
const sheetDashboard = () => import(/* webpackChunkName: "sheets" */ '@/views/sheet/dashboard')
const detail = () => import(/* webeackChunkName: "base" */ '@/views/establishments/detail')
const dashboard = () => import(/* webpackChunkName: "base" */ '@/views/establishments/dashboard')
const referents = () => import(/* webpackChunkName: "referents" */ '@/views/referents/main')
const sheetData = () => import(/* webpackChunkName: "data" */ '@/views/sheet/data')
const sheetCaracteristics = () => import(/* webpackChunkName: "caracs" */ '@/views/sheet/caracteristics')
const data = () => import(/* webpackChunkName: "chunk" */ '@/views/establishments/data')
const o4Results = () => import(/* webpackChunkName: "chunk" */ '@/views/establishments/o4results')
const denominators = () => import(/* webpackChunkName: "denom" */ '@/sui/views/denominators/main')

export default {
  path: '/establishments',
  name: 'establishments',
  component: establishments,
  redirect: 'establishments/list',
  meta: { requiresAuth: true },
  children: [
    {
      path: 'list',
      component: list
    },
    {
      path: ':year/:id',
      component: detail,
      redirect: ':year/:id/dashboard',
      children: [
        {
          path: 'dashboard',
          component: dashboard,
          meta: {
            scrollToTop: true
          }
        },
        {
          path: 'module/:st',
          redirect: 'module/:st/dashboard',
          component: module,
          children: [
            {
              path: 'dashboard',
              component: sheetDashboard,
              meta: {
                scrollToTop: true
              }
            },
            {
              path: 'results',
              component: data,
              meta: {
                scrollToTop: true
              }
            },
            {
              path: 'o4results',
              component: o4Results,
              meta: {
                scrollToTop: true
              }
            },
            {
              path: 'referents',
              component: referents,
              meta: {
                scrollToTop: true
              }
            },
            {
              path: 'caracteristics',
              component: sheetCaracteristics,
              meta: {
                scrollToTop: true
              }
            },
            {
              path: 'data',
              component: sheetData,
              meta: {
                scrollToTop: true
              }
            },
            {
              path: 'sheets',
              redirect: {
                path: 'sheets/add',
                query: {
                  start: 'list'
                }
              },
              component: sheet,
              children: [
                {
                  path: 'add',
                  component: addSheet,
                  meta: {
                    scrollToTop: true
                  }
                },
                {
                  path: ':sid/edit',
                  component: addSheet,
                  meta: {
                    scrollToTop: true
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'denominators',
          component: denominators,
          children: [
            {
              path: ':st',
              component: addSheet,
              meta: {
                scrollToTop: true
              }
            }
          ]
        }
      ]
    }
  ]
}
